import Mixpanel from 'utils/mixpanelService';
import _has from 'lodash/has';

export const trackSaveToListAction = (event, data, auth) => {
  const isSigned = _has(auth, 'uid');
  Mixpanel.track(`${event} - Save To List clicked`, {
    ...data,
    isSigned,
  });
};

export const trackAddToListAction = (event, data) => {
  Mixpanel.track(`${event} - Added to List`, data);
};

export const trackRemoveFromListAction = (event, data) => {
  Mixpanel.track(`${event} - Remove from List`, data);
};
